module.exports = __webpack_public_path__ + "static/media/CRO5B_EDITSINGLE2.c78fdd22.mp4";